import { ChevronDown, ChevronUp } from 'lucide-react';

/**
 * Paginador de leyenda (▲ p/total ▼) — COMPARTIDO por todas las donas para que las
 * flechas sean idénticas en cualquier widget (Mix de pagos, Productos Vendidos, …).
 * Devuelve null si solo hay una página.
 */
export function LegendPager({ page, pages, onPrev, onNext }: {
  page: number;
  pages: number;
  onPrev: () => void;
  onNext: () => void;
}) {
  if (pages <= 1) return null;
  return (
    <div className="mt-2 flex items-center justify-center gap-3 text-slate-400">
      <button onClick={onPrev} disabled={page === 0} aria-label="Anterior" className="rounded p-0.5 hover:text-slate-600 disabled:opacity-30">
        <ChevronUp className="h-4 w-4" />
      </button>
      <span className="text-[11px] tabular-nums">{page + 1}/{pages}</span>
      <button onClick={onNext} disabled={page >= pages - 1} aria-label="Siguiente" className="rounded p-0.5 hover:text-slate-600 disabled:opacity-30">
        <ChevronDown className="h-4 w-4" />
      </button>
    </div>
  );
}
